<template>
    <div class="main_wrap">
        <!-- <div class="banner clearfix" @mouseenter="mouseBanner('enter')" @mouseleave="mouseBanner('leave')">
            <ul>
                <li v-for="list in bannerList">
                    <a :href="list.link || 'javascript:;'">
                        <img :src="list.logo_url">
                    </a>
                </li>
            </ul>
        </div> -->
        <!-- <div class="bodyNext">
            <div class="container">
                <p>快捷服务</p>
                <p class="Englishtex">Express Service</p>
                <div class="list">
                    <div class="listpic" @click="linkTo('/detail/'+list.parent_id+'/'+list.id)" v-for="list in lists">
                        <img :src="list.logo_url" width="320px">
                        <p>{{list.title}}</p>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="container">
            <div class="content_wrap">
                <div class="left">
                    <div class="section">
                        <div class="title">
                            <img src="../images/index_title1.png" alt="">
                            <span @click="toMore(1)">更多</span>
                        </div>
                        <div class="item" v-for="item in section1" :key="item.id" @click="toArt(1, item.id)">
                            <span class="text">{{item.title}}</span>
                            <span class="time">{{item.utime}}</span>
                        </div>
                    </div>
                    <div class="section">
                        <div class="title" style="border-bottom: 0;">
                            <img src="../images/index_title2.png" alt="">
                        </div>
                        <ul class="service_list">
                            <li v-for="item in services" @click="toArt(2, item.id)">
                                <div class="img">
                                    <img :src="item.img">
                                </div>
                                <p>{{item.title}}</p>
                            </li>
                        </ul>
                    </div>
                    <div class="section">
                        <div class="title">
                            <img src="../images/index_title3.png" alt="">
                            <span @click="toMore(3)">更多</span>
                        </div>
                        <div class="item" v-for="item in section2" :key="item.id" @click="toArt(3, item.id)">
                            <span class="text">{{item.title}}</span>
                            <span class="time">{{item.utime}}</span>
                        </div>
                    </div>
                </div>
                <div class="right">
                    <div class="login_box">
                        <img src="../images/login_img.png" class="g_full_img" alt="">
                        <div class="form">
                            <div class="row">
                                <div class="label">账号：</div>
                                <input type="text" placeholder="请输入账号" v-model="username">
                            </div>
                            <div class="row">
                                <div class="label">密码：</div>
                                <input type="password" placeholder="请输入密码" v-model="password">
                            </div>
                            <div class="row code_row">
                                <div class="label">验证码：</div>
                                <input type="text" placeholder="请输入验证码" maxlength="4" v-model="code">
                                <img :src="'gzsa/getVerifiCode?v' + random" @click="refreshCode" alt="">
                            </div>
                            <div class="login_btn" @click="login">登录</div>
                            <div class="links">
                                <span @click="forget">忘记密码？</span><span @click="register">用户注册</span>
                            </div>
                        </div>
                    </div>
                    <div class="imgs" v-if="floatList.length">
                        <img v-for="(item, index) in floatList" :src="item.logo_url" class="g_full_img" @click="toList(item.link)">
                    </div>
                </div>
            </div>
            <div class="shoyeBom">
                <div class="container">
                    <div class="title">
                        <img src="../images/index_title4.png" alt="">
                    </div>
                    <div class="lianjie" @mouseenter="mouseLinks('enter')" @mouseleave="mouseLinks('leave')">
                        <ul class="clearfix links" ref="links">
                            <li v-for="(list, index) in links" class="lianjieLi" :key="index">
                                <a :href="list.link">
                                    <img :src="list.logo_url">
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import api from '../api'
import jquery from 'jquery'
import '../js/unslider-min.js'
export default {
    data() {
        return {
            listData: {
                type: 'parent',
                parent_id: ''
            },
            section1: [], // 通知公告
            services: [], // 服务项目
            section2: [], // 会员信息
            // lists: [],
            floatList: [],
            bannerList: '',
            links: '',
            unslider: '',
            ul: '',
            timer: '',

            /**======== 登录模块 ========*/
            username: '',
            password: '',
            code: '',
            random: ''
            /**======== 登录模块 ========*/
        }
    },
    created() {
        // this.getNavigationListByRank();
        // this.getBannerListByRank();
        this.getFriendLinkList();
        this.getFloatBannerList();
        this.getSection1();
        this.getService();
        this.getSection2();
    },
    methods: {
        refreshCode() {
            this.random = Date.now();
        },
        /**
         * 获取通知公告
         * @Author chenweibiao
         */
        async getSection1() {
            let res = await this.$api.base.getArticleByColumnId({
                column_id: '25',
                page_num: 1,
                page_size: 6,
                area: '',
                industry: '',
                title: ''
            })
            res.repBody.forEach(item => {
                if (item.utime) {
                    item.utime = item.utime.split(' ')[0];
                }
            })
            this.section1 = res.repBody;
        },
        /**
         * 获取一站式服务中【资质服务】的三级菜单列表
         * @Author chenweibiao
         */
        async getService() {
            let res = await this.$api.base.getNavigationList({
                type: 'child',
                parent_id: '4'
            });

            let list = res.repBody.filter(item => item.id === '96')[0].childList;

            list = list.slice(0, 8);

            list.forEach((item, index) => {
                item.img = require('../images/index_icon' + (index + 1) + '.png')
            })

            this.services = list;
        },
        /**
         * 获取一站式服务中【会员服务】【会员宣传】的文章列表
         * @Author chenweibiao
         */
        async getSection2() {
            let res = await this.$api.base.getArticleByColumnId({
                column_id: '60',
                page_num: 1,
                page_size: 6,
                area: '',
                industry: '',
                title: ''
            })

            res.repBody.forEach(item => {
                if (item.utime) {
                    item.utime = item.utime.split(' ')[0];
                }
            })

            this.section2 = res.repBody;
        },
        toMore(type) {
            if (type === 1) {
                this.$router.push({
                    name: 'SecondList',
                    params: {
                        firstId: 3,
                        secondId: 25
                    }
                })
            } else {
                this.$router.push({
                    name: 'ThirdList',
                    params: {
                        firstId: 4,
                        secondId: 110,
                        thirdId: 118
                    }
                })
            }
            
        },
        toArt(type, id) {
            if (type === 1) {
                this.$router.push({
                    name: 'Article',
                    params: {
                        firstId: 3,
                        secondId: 25,
                        thirdId: 0,
                        articleId: id
                    }
                })
            } else if (type === 2) {
                this.$router.push({
                    name: 'ThirdList',
                    params: {
                        firstId: 4,
                        secondId: 96,
                        thirdId: id
                    }
                })
            } else if (type === 3) {
                this.$router.push({
                    name: 'Article',
                    params: {
                        firstId: 6,
                        secondId: 60,
                        thirdId: 0,
                        articleId: id
                    }
                })
            }
        },
        async getFloatBannerList() {
            let res = await this.$api.base.getFloatBannerList();

            this.floatList = res.repBody;
        },
        toList(path) {
            // window.location.href = url;
            if (!path) { return; }
            this.$router.push({
                path
            })
        },
        /**
         * 页面滚动至顶部
         */
        linkTo(path) {
            window.sessionStorage.setItem('top', '1');
            this.$router.go({ path: path });
        },
        /**
         * 获取快捷服务
         */
        // async getNavigationListByRank() {
        //     let res = await this.$api.base.getNavigationListByRank();

        //     this.lists = res.repBody;
        // },
        /**
         * 获取轮播图
         */
        async getBannerListByRank() {
            var that = this;
            let res = await this.$api.base.getBannerListByRank();

            res.repBody.forEach(value => {
                if (value.link) {
                    let match = value.link.match(/detail\/(\d|\/\d)+/);
                    if (match) {
                        value.link = '#!/' + match[0];
                    }
                }
            })
            this.bannerList = res.repBody;
            this.$nextTick(function() {
                var unslider = jquery('.banner').unslider({
                    arrows: false,
                    dots: true, //  显示点导航
                    fluid: false //  支持响应式设计
                })
                that.unslider = unslider.data('unslider');
            })
        },
        /**
         * 轮播图鼠标设置
         */
        mouseBanner(type) {
            if (this.unslider) {
                type === 'enter' ? this.unslider.stop() : this.unslider.start();
            }
        },
        /**
         * 获取友情链接
         */
        async getFriendLinkList() {
            let res = await this.$api.base.getFriendLinkList();

            if (res.repBody.length > 3) {
                this.links = res.repBody.concat(res.repBody);
            } else {
                this.links = res.repBody;
            }
            this.$nextTick(() => {
                this.initLinks();
            })
        },
        /**
         * 友情链接滚动设置ul宽度
         */
        initLinks() {
            let ul = this.$refs.links;
            let lis = document.querySelectorAll('.links li');
            ul.style.width = 190 * lis.length + 'px';
            this.timer = setInterval(() => {
                this.move();
            }, 50);
        },
        /**
         * 友情链接滚动定时器
         */
        move() {
            let ul = this.$refs.links;
            if (!ul) {
                clearInterval(this.timer);
            }
            if (ul.offsetLeft < -ul.offsetWidth / 2) {
                ul.style.left = '0';
            } else if (ul.offsetLeft > 0) {
                ul.style.left = -ul.offsetWidth / 2 + 'px';
            }
            ul.style.left = ul.offsetLeft - 2 + 'px';
        },
        /**
         * 友情链接滚动鼠标设置
         */
        mouseLinks(type) {
            if (type === 'enter') {
                clearInterval(this.timer);
            } else {
                this.timer = setInterval(() => {
                    this.move();
                }, 50);
            }
        },
        async login() {
            const self = this;

            let res = await this.$api.base.verifiCode({
                code: this.code
            });

            if (!res.repBody.result) {
                this.$Message.error('验证码输入错误');
                return;
            }

            window.loginCallBack = function(e) {
                if (e.code == "1") {
                    window.location.href = "http://app.gzsia.cn" + e.target;
                } else {
                    self.$Message.error(e.msg);
                }
            }

            jquery.ajax({
                type : "get",
                url : 'http://app.gzsia.cn/authservice.jsp',
                dataType : 'jsonp',
                jsonpCallback : "loginCallBack",
                data : {
                    "User" : this.username,
                    "Password" : this.password, //MipEncodeCode(logonPassword),
                    "savetime" : "7"
                },
                success : function(e) {
                    console.log(e);
                },
                error: function(request, textStatus, errorThrown) {
                    console.log(request);
                }
            })
        },
        forget() {
            window.location.href = 'http://app.gzsia.cn/admin/mmzh/index.jsp?flag=1';
        },
        register() {
            window.location.href = 'http://app.gzsia.cn/ssia/khgl/qyyhzc/index.jsp?flag=1';
        }
    }
}
</script>
<style lang="scss" scoped>
    .main_wrap {
        padding: 30px 0;
        background: url(../images/index_bottom.jpg) bottom center / 100% auto no-repeat;
        .content_wrap {
            display: flex;
            justify-content: space-between;
            padding: 30px 0;
            .left {
                width: 65%;
                padding-left: 5px;
                .section {
                    &:not(:first-child) {
                        padding-top: 30px;
                    }
                    .title {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 10px 0;
                        border-bottom: 2px solid #0093dd;
                        img {
                            width: 100px;
                        }
                        span {
                            font-size: 12px;
                            color: red;
                            cursor: pointer;
                        }
                    }
                    /** 服务项目 */
                    .service_list {
                        display: flex;
                        flex-wrap: wrap;
                        li {
                            width: 20%;
                            margin: 30px 2.5% 0;
                            text-align: center;
                            cursor: pointer;
                            .img {
                                position: relative;
                                width: 60px;
                                height: 60px;
                                margin: 0 auto;
                                img {
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    max-width: 100%;
                                    max-height: 100%;
                                    transform: translate(-50%, -50%);
                                }
                            }
                            p {
                                padding-top: 10px;
                                color: #0093dd;
                                font-size: 14px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                    .item {
                        display: flex;
                        justify-content: space-between;
                        padding: 8px 0;
                        font-size: 14px;
                        border-bottom: 1px dashed #d8d8d8;
                        cursor: pointer;
                        &:hover {
                            .text {
                                color: #eb1111;
                                background: url(../images/index_icon_active.png) left 4px no-repeat;
                                transform: translateX(1px);
                            }
                        }
                        .text {
                            flex: 1;
                            padding-left: 15px;
                            color: #666;
                            background: url(../images/index_icon.png) left 4px no-repeat;
                            transition: all .4s linear;
                        }
                        .time {
                            color: #999;
                        }
                    }
                }
            }
            .right {
                width: 30%;
                .login_box {
                    padding: 20px 40px;
                    border-radius: 10px;
                    border: 1px solid #0093dd;
                    .form {
                        padding-top: 20px;
                        .row {
                            position: relative;
                            margin: 10px 0;
                            padding-left: 60px;
                            .label {
                                position: absolute;
                                top: 0;
                                left: 0;
                                font-size: 14px;
                                line-height: 40px;
                            }
                            input {
                                display: block;
                                width: 98%;
                                border: 0;
                                line-height: 40px;
                                font-size: 14px;
                                padding-left: 2%;
                                background: #fff1f1;
                                outline: none;
                            }
                        }
                        .code_row {
                            padding-right: 120px;
                            img {
                                position: absolute;
                                top: 0;
                                right: 0;
                                cursor: pointer;
                            }
                        }
                        .login_btn {
                            line-height: 40px;
                            color: white;
                            text-align: center;
                            font-size: 16px;
                            cursor: pointer;
                            background: red;
                        }
                        .links {
                            padding-top: 20px;
                            font-size: 0;
                            span {
                                display: inline-block;
                                width: 50%;
                                text-align: center;
                                font-size: 14px;
                                color: red;
                                cursor: pointer;
                            }
                        }
                    }
                }
                .imgs {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    margin-top: 30px;
                    padding: 10px;
                    border: 1px solid #eee;
                    border-radius: 6px;
                    img {
                        margin-top: 5px;
                        margin-bottom: 10px;
                        &:not(:first-child) {
                            width: 49%;
                            margin-bottom: 0;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }

.bodyNext {
    width: 100%;
    height: 600px;
    background-color: blue;
    background: url(../images/bodyBg.png) center top no-repeat;
    background-size: contain;
    padding-top: 46px;
    text-align: center;
    position: relative;
    box-sizing: border-box;
}

.bodyNext p:first-child {
    font-size: 30px;
    color: #fff;
}

.bodyNext .Englishtex {
    font-size: 14px;
    color: #fff;
    font-family: '微软雅黑'
}

.list {
    box-sizing: border-box;
    /*margin: 29px 150px;*/
    margin-top: 29px;
}

.list .listTable {
    width: 100%;
}

.list .listTable td {}

.list p {
    color: #fff;
    font-size: 15px;
    font-family: '黑体';
    opacity: .8;
    filter: alpha(opacity=80);
}

.service {
    width: 40px;
    height: 43px;
    background: url(../images/peoper.png) center 10px no-repeat;
}

.attend {
    width: 60px;
    height: 33px;
    background: url(../images/manPer.png) center 20px no-repeat;
}

.company {
    width: 48px;
    height: 29px;
    background: url(../images/woshou.png) center 24px no-repeat;
}

.shoyeBom {
    height: 240px;
    // background: url(../images/shu.png) repeat-x;
    box-sizing: border-box;
    padding-top: 60px;
}

.shoyeBom .title img {
    width: 100px;
}

.lianjie {
    position: relative;
    height: 90px;
    overflow: hidden;
    margin-top: 10px;
}

.lianjie ul {
    position: absolute;
    top: 0;
    left: 0;
    white-space: nowrap;
    font-size: 0;
}

.lianjie a {
    position: relative;
    display: block;
    height: 100%;
    -webkit-transition: all .3s;
    -o-transition: all .3s;
    transition: all .3s;
    border-radius: 6px;
    background: white;
}

.lianjie a:hover {
    // -webkit-transform: scale(1.1);
    // -ms-transform: scale(1.1);
    // -o-transform: scale(1.1);
    // transform: scale(1.1);
    box-shadow: 0 0 10px rgba(255, 0, 0, .2);
}

.lianjieLi {
    display: inline-block;
    width: 184px;
    height: 90px;
    padding: 10px;
    cursor: pointer;
    
}

.lianjieLi img {
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 100%;
    max-height: 100%;
    border-radius: 8px;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    // box-shadow: 0 0 14px rgba(255, 0, 0, .2);
    // background: white;
}

.listpic {
    display: inline-block;
    height: 220px;
    width: 320px;
    position: relative;
    cursor: pointer;
    /*float: left;*/
}

.listpic img {
    width: 90%;
    -webkit-box-shadow: 0 20px 30px rgba(0, 0, 0, .5);
    box-shadow: 0 20px 30px rgba(0, 0, 0, .5);
    /*position: relative;*/

}

.listpic p {
    /*bottom:8px;
    position: absolute;*/
    text-align: center;
    position: absolute;
    left: 121px;
    bottom: 25px;
    font-family: '黑体';
}

.listpic:nth-of-type(4),
.listpic:nth-of-type(5),
.listpic:nth-of-type(6) {
    margin-top: 20px;
}

.listpic:nth-of-type(4) p,
.listpic:nth-of-type(5) p,
.listpic:nth-of-type(6) p {
    color: #133259;
}
</style>